import React, { useState, useEffect, useCallback } from "react";
import { Spinner } from "react-bootstrap";
import axiosInstance from "../../../services/AxiosInstance";
import { format } from "date-fns";

const BADGE = {
  posted: ["success", "Posted"], queued: ["info", "Scheduled"], needs_review: ["warning", "In review"],
  rejected: ["secondary", "Rejected"], skipped: ["secondary", "Skipped"], failed: ["danger", "Failed"], approved: ["info", "Approved"],
};

const AutopilotActivity = () => {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(25);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axiosInstance.get(`autopilot/activity?page=${page}`);
      setRows(data.data || []); setTotal(data.total || 0); setLimit(data.limit || 25);
    } catch {}
    setLoading(false);
  }, [page]);
  useEffect(() => { load(); }, [load]);

  const pages = Math.max(1, Math.ceil(total / limit));
  return (
    <div className="card">
      <div className="card-body">
        {loading ? <div className="text-center py-4"><Spinner animation="border" variant="primary" /></div> : rows.length === 0 ? (
          <p className="text-muted text-center my-4">No activity yet.</p>
        ) : (
          <div className="table-responsive">
            <table className="table table-sm">
              <thead><tr><th>When</th><th>Source</th><th>Item</th><th>Result</th><th>Why</th></tr></thead>
              <tbody>
                {rows.map((r) => {
                  const [bg, label] = BADGE[r.status] || ["secondary", r.status];
                  return (
                    <tr key={r._id}>
                      <td className="text-nowrap small">{format(new Date(r.updatedAt), "dd MMM HH:mm")}</td>
                      <td className="small">{r.sourceName}</td>
                      <td className="small" style={{ maxWidth: 280 }}>{r.link ? <a href={r.link} target="_blank" rel="noopener noreferrer">{r.title || r.link}</a> : r.title}</td>
                      <td><span className={`badge badge-${bg}`}>{label}</span></td>
                      <td className="small text-muted">{r.reason || (r.score ? `Score ${r.score}` : "")}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
        {pages > 1 && (
          <div className="d-flex justify-content-between align-items-center">
            <button className="btn btn-outline-secondary btn-sm" disabled={page <= 1} onClick={() => setPage(page - 1)}>Previous</button>
            <span className="small text-muted">Page {page} of {pages}</span>
            <button className="btn btn-outline-secondary btn-sm" disabled={page >= pages} onClick={() => setPage(page + 1)}>Next</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AutopilotActivity;
